import { forwardRef, type Ref, type SVGProps } from "react";
const IconPointerDownFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.85 2.47A1 1 0 0 0 29 2H3a1 1 0 0 0-.89 1.45l13 26a1 1 0 0 0 1.78 0l13-26a1 1 0 0 0-.04-.98" />
  </svg>
);
const ForwardRef = forwardRef(IconPointerDownFilledSVG);
ForwardRef.displayName = "IconPointerDownFilled";
export { ForwardRef as IconPointerDownFilled };
